// extracted by mini-css-extract-plugin
export default {"main":"mainDashboard_main__9GSRk"};